<ng-container *ngIf="!router.url.includes('/chat')">
  <!-- Transparent backdrop — closes the dial -->
  <div class="fab-overlay" *ngIf="isOpen" (click)="toggleOpen()"></div>

  <!-- Speed-dial container -->
  <div class="fab-container" [class.is-open]="isOpen">
    <!-- Action items (visible when dial is open) -->
    <div class="fab-actions" *ngIf="isOpen">
      <!-- Task — always available -->
      <div class="fab-action" style="animation-delay: 0.09s">
        <span class="fab-action-label">
          <ng-container *ngIf="context; else genericTask">
            New Task
            <span class="entity-tag">{{ context.entityType }}</span>
          </ng-container>
          <ng-template #genericTask>New Task</ng-template>
        </span>
        <button class="fab-action-btn task-btn" (click)="openTask()" title="Create Task">
          <i class="pi pi-check-square"></i>
        </button>
      </div>

      <!-- Comment — only when entity context is set -->
      <div class="fab-action" *ngIf="context" style="animation-delay: 0.05s">
        <span class="fab-action-label">
          Comments
          <span class="entity-tag">{{ context.entityType }}</span>
        </span>
        <button class="fab-action-btn comment-btn" (click)="openComments()" title="View Comments">
          <i class="pi pi-comment"></i>
        </button>
      </div>

      <!-- Chat — always available, shows unread badge -->
      <div class="fab-action" style="animation-delay: 0.01s">
        <span class="fab-action-label">
          <ng-container *ngIf="context; else genericChat">
            Chat
            <span class="entity-tag">{{ context.entityType }}</span>
          </ng-container>
          <ng-template #genericChat>Messages</ng-template>
          <!-- <span *ngIf="totalUnread > 0" class="unread-pill">
            {{ totalUnread > 99 ? '99+' : totalUnread }}
          </span> -->
        </span>
        <button class="fab-action-btn chat-btn" (click)="openChat()" title="Chat">
          <i class="pi pi-comments"></i>
        </button>
      </div>
    </div>

    <!-- Main trigger button -->
    <button
      class="fab-main"
      [class.has-unread]="totalUnread > 0 && !isOpen"
      [class.is-open]="isOpen"
      (click)="toggleOpen()"
      [title]="isOpen ? 'Close' : 'Actions'"
    >
      <span class="fab-main-icon" [class.rotated]="isOpen">
        <i class="pi pi-plus" style="margin-left: 0px; color: #fff; font-weight: bold;"></i>
      </span>
      <!-- <span *ngIf="totalUnread > 0 && !isOpen" class="fab-badge">
        {{ totalUnread > 99 ? '99+' : totalUnread }}
      </span> -->
    </button>
  </div>

  <!-- ── Chat modal (entity-linked or general) ─────────────── -->
  <!-- <p-dialog
    [(visible)]="showChatModal"
    [modal]="true"
    [draggable]="true"
    [resizable]="false"
    [closable]="false"
    [style]="{ width: '1140px', height: '720px' }"
    [contentStyle]="{ padding: '0', overflow: 'hidden', height: 'calc(100% - 52px)' }"
    styleClass="chat-modal-dialog"
    appendTo="body"
  >
    <ng-template pTemplate="header">
      <span class="chat-modal-title"><i class="pi pi-comments"></i>&nbsp; Messages</span>
      <div class="chat-modal-actions">
        <button
          class="chat-modal-action-btn"
          (click)="popOutChat()"
          title="Pop out into new window"
        >
          <i class="pi pi-external-link"></i>
        </button>
        <button class="chat-modal-close" (click)="showChatModal = false" title="Close">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </ng-template>
    <app-chat [initialChannelId]="pendingChannelId"></app-chat>
  </p-dialog> -->

  <!-- ── Comments panel (requires entity context) ──────────── -->
  <app-comments-panel
    *ngIf="context"
    [(visible)]="showCommentsPanel"
    [entityType]="context.entityType"
    [entityId]="context.entityId"
  ></app-comments-panel>

  <!-- ── Task quick-create modal ───────────────────────────── -->
  <app-task-quick-create-modal
    [(visible)]="showTaskModal"
    [context]="taskContext"
    (taskCreated)="onTaskCreated($event)"
  ></app-task-quick-create-modal>

  <!-- ── Entity channel picker (patient / provider / etc.) ─ -->
  <app-entity-channel-picker
    *ngIf="context"
    [(visible)]="showEntityChannelPicker"
    [channels]="entityChannels"
    [entityType]="context.entityType"
    [entityDisplayName]="context.entityDisplayName || ''"
    (channelSelected)="onEntityChannelSelected($event)"
    (createNew)="onCreateEntityChannel($event)"
  ></app-entity-channel-picker>
</ng-container>
